import { render, staticRenderFns } from "./scroll-wrap.vue?vue&type=template&id=024ae5c5&scoped=true&"
import script from "./scroll-wrap.vue?vue&type=script&lang=js&"
export * from "./scroll-wrap.vue?vue&type=script&lang=js&"
import style0 from "./scroll-wrap.vue?vue&type=style&index=0&id=024ae5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ae5c5",
  null
  
)

export default component.exports